module.exports = __webpack_public_path__ + "public/img/total8.b6a75d9d.png";